var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useQuery } from '@apollo/client';
import { STANDINGS_USER_ACTIVITIES } from 'common/graphql/queries/standings/standings-user-activities';
import UserAvatar from 'components/UserAvatar/UserAvatar';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Slider from 'react-slick';
import history from 'store/history';
import HelperFunctions from 'utils/HelperFunctions';
var RecentActivityItem = function (_a) {
    var standingsUserActivity = _a.standingsUserActivity;
    var _b = useTranslation(), t = _b.t, i18n = _b.i18n;
    var getActivityDate = HelperFunctions.getFancyDate;
    var activitySportDetails = HelperFunctions.getSportDetailsBySportName(standingsUserActivity.sportName, 'activity');
    return (_jsxs("div", __assign({ className: "flex flex-row items-center justify-between w-full", onClick: function () {
            history.push("/standings-activities/".concat(standingsUserActivity.standingsId));
        } }, { children: [_jsxs("div", __assign({ className: "flex flex-row space-x-5" }, { children: [_jsx(UserAvatar, { style: "h-28 w-28", profilePhoto: { url: standingsUserActivity.userProfilePhotoUrl || '' }, firstName: standingsUserActivity.firstName }, void 0), _jsxs("div", __assign({ className: "flex flex-col" }, { children: [_jsx("p", { children: "".concat(standingsUserActivity.firstName, " ").concat(standingsUserActivity.lastName) }, void 0), _jsx("p", __assign({ className: "text-xxs text-grey" }, { children: getActivityDate(standingsUserActivity.activityStartDate, i18n.language) }), void 0)] }), void 0)] }), void 0), _jsx("p", { children: " - " }, void 0), _jsxs("div", __assign({ className: "flex flex-row space-x-5" }, { children: [_jsx("p", { children: "".concat(((standingsUserActivity.validatedDistance || 0) / 1000).toFixed(1), " ").concat(t('км')) }, void 0), _jsx("div", { children: activitySportDetails && _jsx("div", { children: activitySportDetails.children }, void 0) }, void 0)] }), void 0)] }), void 0));
};
var RecentActivitiesCarousel = function (_a) {
    var standingsId = _a.standingsId;
    var t = useTranslation().t;
    var _b = useQuery(STANDINGS_USER_ACTIVITIES, {
        variables: {
            standingsId: standingsId,
            limit: 4
        }
    }), data = _b.data, loading = _b.loading, refetch = _b.refetch;
    var settings = {
        arrows: false,
        dots: true,
        fade: true,
        infinite: true,
        autoplay: true,
        speed: 500,
        autoplaySpeed: 3000,
        slidesToShow: 1,
        slidesToScroll: 1,
        waitForAnimate: false
    };
    useEffect(function () {
        var handleVisibilityChange = function () {
            if (document.visibilityState === 'visible') {
                console.log('Tab is visible, refetching standings recent user activities...');
                refetch();
            }
        };
        document.addEventListener('visibilitychange', handleVisibilityChange);
        return function () {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, [refetch]);
    if (data && data.standingsUserActivities && data.standingsUserActivities.length === 0 && !loading) {
        return _jsx("p", __assign({ className: "text-12" }, { children: t('Недавние тренировки не найдены') }), void 0);
    }
    return data && data.standingsUserActivities && data.standingsUserActivities.length > 0 ? (_jsx(Slider, __assign({}, settings, { className: "" }, { children: data.standingsUserActivities.map(function (standingsUserActivity, index) {
            return _jsx(RecentActivityItem, { standingsUserActivity: standingsUserActivity }, index);
        }) }), void 0)) : null;
};
export default RecentActivitiesCarousel;
